module.exports = __webpack_public_path__ + "img/close-btn.5e1f2c3e.svg";